import { render, staticRenderFns } from "./LedgerDashboard.vue?vue&type=template&id=569f8ed9&scoped=true"
import script from "./LedgerDashboard.vue?vue&type=script&lang=js"
export * from "./LedgerDashboard.vue?vue&type=script&lang=js"
import style0 from "./LedgerDashboard.vue?vue&type=style&index=0&id=569f8ed9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569f8ed9",
  null
  
)

export default component.exports